import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from 'src/app/shares/services/user.service';
import { UserGroupService } from 'src/app/shares/services/user-group.service';
import { GlobalsService, TranslateHelpersService } from 'src/app/shares/helpers';
import { ResponseResult } from 'src/app/shares/interfaces';
import { StatusCode, Action, Lang, ImageType } from 'src/app/shares/constants';
import { AddressService } from 'src/app/shares/services';
import { Md5 } from 'ts-md5/dist/md5';

@Component({
  selector: 'app-user-data-partner-detail',
  templateUrl: './user-data-partner-detail.component.html',
  styleUrls: ['./user-data-partner-detail.component.scss']
})
export class UserDataPartnerDetailComponent implements OnInit {
  formGroup: FormGroup;
  isShowForm: boolean = false;
  type: string = '';
  model: any;
  dataFilter: any;
  password: string = '';
  configImage: any = {colIn: 12, colIm: 12};
  //translate
  hideLeader: boolean;
  lang: any;
  isAgronomist: boolean = false;
  mainId?: number = null;
  roleId: number= 12; // 12 is agronomist, 7 is Fermenter,4 is sourcing 
  partnerType: number = 1;
  selectUserLabel: string ='Chọn nông dân';
  selectUserLabelPlaceHolder: string ='Nông dân';
  @Input() configDetail: any;
  @Output() eventAction = new EventEmitter<any>();

  constructor(private fb: FormBuilder,
    private userService: UserService,
    private addressService: AddressService,
    private userGroupService: UserGroupService,
    private translate: TranslateHelpersService,
    private globals: GlobalsService) {
    this.setLabelText();
    this.model = {};
    this.dataFilter = {};
    this.lang = Lang;
  }

  ngOnInit() {
    this.buildForm();
  }

  getUserDetail(){
    this.globals.showLoading();
    this.userService.getById(this.model.userId).subscribe((res: ResponseResult) => {
      this.globals.hideLoading();
      if (res.statusCode === StatusCode.Status200OK) {
        this.model = res.data;
        const datadt = { ...this.model };
        this.password = datadt.passWord;
        this.model.image = ImageType + this.model.image;
        this.model.countryId = 237;
        this.getProvinces(this.model.countryId);
        this.buildForm();
        this.isShowForm = true;
      } else {
        this.globals.getErrorMessage(res.message);
      }
    }, error => {
      this.globals.getError();
      this.globals.hideLoading();
    });
  }

  buildForm() {
    this.formGroup = this.fb.group({
      userCode: [this.model.userCode, [
        Validators.required
      ]],
      userName: [this.model.userName, [
      ]],
      fullName: [this.model.fullName, [
        Validators.required
      ]],
      leaderId: [this.model.leaderId, [
      ]],
      email: [this.model.email, [
      ]],
      address: [this.model.address, [
      ]],
      subDistrict: [this.model.subDistrict, [
      ]],
      danToc: [this.model.danToc, [
      ]],
      countryId: [this.model.countryId, [
      ]],
      provinceId: [this.model.provinceId, [
      ]],
      districtId: [this.model.districtId, []],
      wardId: [this.model.wardId, []],
      userSelectedId: [this.model.userSelectedId, []],
      phoneNumber: [this.model.phoneNumber, [
      ]],
      // description: [this.model.description, [
      // ]],
      // description1: [this.model.description1, [
      // ]],
      passWord: [this.model.passWord, []],
      nameMarriage: [this.model.nameMarriage, []],
      identity: [this.model.identity, []],
      note: [this.model.note, []],
    });
    
  }

  open(): void {
    this.configDetail.visible = true;
  }

  close(): void {
    this.configDetail.visible = false;
  }

  getResultImage($event){
    this.model.image = $event.image;
  }

  getUserGroups() {
    this.globals.showLoading();
    this.userGroupService.getAll().subscribe((res: ResponseResult) => {
      this.globals.hideLoading();
      if (res.statusCode === StatusCode.Status200OK) {
        this.dataFilter.userGroups = res.data.items;
      } else {
        this.globals.getErrorMessage(res.message);
      }
    }, error => {
      this.globals.getError();
      this.globals.hideLoading();
    });
  }

  getFarmers() {
    this.globals.showLoading();
    this.dataFilter.userSelects = [];
    this.userService.getFarmers(this.partnerType).subscribe((res: ResponseResult) => {
      this.globals.hideLoading();
      if (res.statusCode === StatusCode.Status200OK) {
        this.dataFilter.userSelects = res.data;
      } else {
        this.dataFilter.userSelects = [];
      }
    }, error => {
      this.globals.getError();
      this.globals.hideLoading();
    });
  }

  getCountries(langId: string = '') {
    this.globals.showLoading();
    this.dataFilter.countries = [];
    this.addressService.getCountries(langId).subscribe((res: ResponseResult) => {
      this.globals.hideLoading();
      if (res.statusCode === StatusCode.Status200OK) {
        this.dataFilter.countries = res.data;
        if (this.model.countryId == null) {
          this.model.countryId = this.dataFilter.countries[0].id;
        }
        this.getProvinces(this.model.countryId);
      } else {
        this.globals.hideLoading();
        this.globals.getErrorMessage(res.message);
      }
    }, error => {
      this.globals.getError();
      this.globals.hideLoading();
    });
  }

  getProvinces(id: number, langId: string = '') {
    this.globals.showLoading();
    this.dataFilter.provinces = [];
    this.addressService.getProvinces(id, langId).subscribe((res: ResponseResult) => {
      this.globals.hideLoading();
      if (res.statusCode === StatusCode.Status200OK) {
        this.dataFilter.provinces = res.data;
        if (this.model.provinceId == null) {
          this.model.provinceId = this.dataFilter.provinces[0].id;
        }
      } else {
        this.globals.getErrorMessage(res.message);
        this.globals.hideLoading();
      }
    }, error => {
      this.globals.getError();
      this.globals.hideLoading();
    });
  }
  

  getDistricts(id: number, langId: string = '') {
    this.dataFilter.districts = [];
    this.globals.showLoading();
    this.addressService.getDistricts(id, langId).subscribe((res: ResponseResult) => {
      this.globals.hideLoading();
      if (res.statusCode === StatusCode.Status200OK) {
        this.dataFilter.districts = res.data;
        if (this.model.districtId == null) {
          this.model.districtId = this.dataFilter.districts[0].id;
        }
      } else {
        this.globals.hideLoading();
        this.globals.getErrorMessage(res.message);
      }
    }, error => {
      this.globals.hideLoading();
      this.globals.getError();
    });
  }

  getWards(id: number, langId: string = '') {
    this.dataFilter.wards = [];
    this.globals.showLoading();
    this.addressService.getWards(id, langId).subscribe((res: ResponseResult) => {
      this.globals.hideLoading();
      if (res.statusCode === StatusCode.Status200OK) {
        this.dataFilter.wards = res.data;
        if (this.model.wardId == null) {
          this.model.wardId = this.dataFilter.wards[0].id;
        }
      } else {
        this.globals.hideLoading();
        this.globals.getErrorMessage(res.message);
      }
    }, error => {
      this.globals.hideLoading();
      this.globals.getError();
    });
  }

  submitForm() {
    if (!this.formGroup.valid) { return; }
    this.convertObject(this.formGroup.value);
    this.model.mainId = this.mainId;
    this.model.isAgronomist = this.isAgronomist;
    this.globals.showLoading();
  
    var userPartner = { 
      MainUserId:this.mainId, 
      SubUserId:this.formGroup.value.userSelectedId,
      Type: this.partnerType
   }; 
    this.userService.addPartnerMember(userPartner).subscribe((res) => {
      this.globals.hideLoading();
      if (res.statusCode === StatusCode.Status200OK) {
        this.globals.saveSuccess();
        this.eventAction.emit({
          event: Action.Create,
          success: true
        });
        this.close();
      } else {
        this.globals.getErrorMessage(res.message);
      }
    }, (error) => {
      this.globals.hideLoading();
      this.globals.saveError();
    });
  }

  convertObject(data) {
    Object.keys(data).forEach(e => {
      this.model[e] = data[e];
    });
  }

  changeUserSelected($event){
    let data = this.dataFilter.userSelects.filter(c=> {return c.userId == $event});
    if(data.length > 0){
      setTimeout(() => {
          this.formGroup.controls["fullName"].setValue(data[0].fullName);
          this.formGroup.controls["address"].setValue(data[0].address);
          this.formGroup.controls["provinceId"].setValue(data[0].provinceId);
          this.formGroup.controls["districtId"].setValue(data[0].districtId);
          this.formGroup.controls["wardId"].setValue(data[0].wardId);
          this.formGroup.controls["userCode"].setValue(data[0].userCode);
          this.formGroup.controls["phoneNumber"].setValue(data[0].phoneNumber);
          this.formGroup.controls["email"].setValue(data[0].email);
      }, 1);
    }
  }
  
  // Update Agronomist
  editDataV2(data, hideLeader: boolean = false, groupId: number = 0, mainId: number = 0, isAgronomist: boolean = true, partnerType: number = 1) {
    this.partnerType = partnerType;
    if(partnerType == 1){
      this.roleId = 12;
    }else if(partnerType ==2){
      this.roleId = 7;
    }else if(partnerType == 3){
      this.roleId = 4;
    }
    this.isAgronomist = isAgronomist;
    this.hideLeader = !hideLeader;
    this.mainId = mainId;
    this.model = data;
    if (data == null) {
      this.model = {};
      if(mainId > 0){
        this.model.mainId = mainId;
      }
      this.type = Action.Create;
    } else {
      this.type = Action.Edit;
      this.getUserDetail();
    }

    if(groupId > 0){
      this.model.userGroupId = groupId;
    }

    this.isShowForm = false;
    this.dataFilter = {};
    this.model.countryId = 237;
    if(this.type == Action.Create){
      this.getProvinces(this.model.countryId);
    }
    this.getUserGroups();
    this.getUserAgronomists();
    this.getFarmers();
    this.setLabelText();

    setTimeout(() => {
      this.buildForm();
      this.isShowForm = true;
    });
  }

  setLabelText(){
    if(this.partnerType == 3){
      this.selectUserLabel = "Chọn lên men";
      this.selectUserLabelPlaceHolder = "Lên men";
    }
  }
  getUserAgronomists() {
    this.globals.showLoading();
    this.userService.getByUserByRole(this.roleId).subscribe((res: ResponseResult) => {
      this.globals.hideLoading();
      if (res.statusCode === StatusCode.Status200OK) {
        this.dataFilter.userLeaders = res.data.items;
        if (this.type === Action.Create && (!this.model.leaderId || this.model.leaderId == 0)) {
          this.model.leaderId = this.mainId;
          this.formGroup.controls["leaderId"].setValue(this.mainId);
        }
        setTimeout(() => {
          if (this.type === Action.Create && this.model.leaderId && this.model.leaderId > 0) {
            this.formGroup.controls["leaderId"].setValue(Number(this.mainId));
          }
        }, 1);
       
      } else {
        this.dataFilter.userLeaders = [];
      }
    }, error => {
      this.globals.getError();
      this.globals.hideLoading();
    });
  }
}
